import { render, staticRenderFns } from "./extraMenu.vue?vue&type=template&id=2f230ab5&scoped=true"
import script from "./extraMenu.vue?vue&type=script&lang=js"
export * from "./extraMenu.vue?vue&type=script&lang=js"
import style0 from "./extraMenu.vue?vue&type=style&index=0&id=2f230ab5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f230ab5",
  null
  
)

export default component.exports